import { useState } from 'react';

import { PAGINATION_LIMIT } from '@constants/generic';

// Keeps the first visible row on screen when the page size changes
export const getPageForPageSize = (
  page: number,
  currentPageSize: number,
  nextPageSize: number
) => Math.floor(((page - 1) * currentPageSize) / nextPageSize) + 1;

const useTablePagination = (initialPageSize = PAGINATION_LIMIT) => {
  const [page, setPage] = useState<number>(1);
  const [pageSize, setPageSizeState] = useState<number>(initialPageSize);

  const setPageSize = (nextPageSize: number) => {
    if (nextPageSize === pageSize) return;
    setPage(getPageForPageSize(page, pageSize, nextPageSize));
    setPageSizeState(nextPageSize);
  };

  return { page, setPage, pageSize, setPageSize };
};

export default useTablePagination;
